module.exports = {
  "language": "2",
  "success": true,
  "data": {
    "headText": {
      "pageOne": {
        "name": "Home",
        "pageText": {
          "Product": "Product Display",
          "series": {
            "one": "Sunscreen series",
            "two": "Swimwear Series",
            "three": "Life Series"
          },
          "introduce": {
            "patent": "VVC national patent brand. The brand's first textile conversion light source, effectively convert natural light (sunlight) into the spectrum required by the skin, let people wear the corresponding products, can experience cell activation in the most comfortable and cool state. Combining the needs of modern people in outdoor activities and sunscreen skin care, with international design concepts and medical professional attitudes, we will create fashionable outdoor products with super sunscreen, skin care and health care.",
            "brief": "VVC Profile"
          },
          "story": {
            "storyText": "Brand Story",
            "brand": {
              "idea": "Brand concept",
              "style": "product style",
              "origin": "Brand origin"
            }
          }
        }
      },
      "pageTwo": {
        "name": "Sunscreen"
      },
      "pageThree": {
        "name": "Swimwear"
      },
      "pageFour": {
        "name": "Life"
      },
      "pageFive": {
        "name": "Vision",
        "pageText": {
          "visionText": "VVC Vision System",
          "column": "There are only a variety of videos and stylings seen in the bucket, as well as the videos and costumes of the gorgeous performances of the natural combination players. In addition, I also want to enjoy the events and events hosted on the desktop."
        }
      },
      "pageSix": {
        "name": "joint",
        "pageText": {
          "storeText": "VVC Outlets",
          "address": "address",
          "addressText": "1st Floor, Shop 127, Floor 1, Block B, Hangzhou Tower, Hangzhou Wulin Plaza, 310000, Hangzhou Email: store_hangzhou_tower@givenchy.com Tel: +86 571 86 72 27 70"
        }
      },
      "pageSeven": {
        "name": "SecurityCheck",
        "pageText": {
          "query": "authorized query",
          "inputQuery": "Please enter Taobao/Tmall ID",
          "buttonQuery": "Click to query"
        }
      },
      "pagenine":{
        "name":'Womens Strap Onepiece Swimsuit Black Flower',
        "span":" Size Small,Medium,Large Material",
        "shop":'Will choose goods ',
        "shuli":'quantity',
        "chima":'Choose size',
        "yasn":"choose a color",
        "hongs":'red',
        "bais":'white',
        "shops":'Goods together',
        "houmai":'Buy now',
        'shoupcar':'add to shopping cart ',  
      },
      "foot":{
        "vvname":'About the VVC',
        'ygkp':'Sunshine science',
        'vvcfz':'vvc Unique textile technology',
        'zlbl':'Patent cloth',
        'ppsm':'Brand mission',
        "crfs":'Adult is prevented bask in',
        'nxfs':'Male is prevented bask in',
        'nvfs':'Women is prevented bask in',
        "etfs":"Sonnenlotion",
        "lmhz":'co-branding',
        'mxlik':'Star joint payment',
        'atls':'Outlets',
        'msd':'duty-free shop',

        "fwcx":'anti-forgery check',
        'dlcx':'The Sales Network',
        'fcx':'anti-forgery check',
        'tbtmcx':'Taobao Tmall authorization query',
        "zxrx":'helpline 400-1818-766',
      },
      "classlist":{
        "title":"Hot commodity"
      },
        "entity":{
          "title":"VVC A physical store"
      },
      "viewmore":{
        "title":"more"
    },
    "jojnt":{
      "pingpai":'Brand inquiry',
      "daili":'Proxy query',
      "dangwei":'Security check',
      'tianmao':'Tmall authorized inquiry',
      "qindail":'Please enter a proxy query',
      "qindanw":'Please enter security check',
      "qintian":'Please enter the Tmall query',
      "chaxun":'Inquire',
      "fangwibianm":'Please enter the product packaging 12-digit security code',
      "shouci":'The first inquiry will show the authenticity of the product. If the product inquiry is not performed by the user for many times, please contact the official website of the official website.',
      "gongz":"Public number inquiry VVC",
      'shouh':'After-sales service 400-1818-766',
      "searchResult":'search result',
      'gengdyi':'More information is available on the official account',
      "chauxun":'The query number',
      "chuanxhsi":'query time',
  }
    }
  }
}



// WEBPACK FOOTER //
// ./src/data/en.js